export default {
  computed: {
    stateRegion: {
      get () {
        return this.placement.region
      },

      set (value) {
        this.setPlacementProperty({ property: 'region', value })
      }
    },

    stateEmail: {
      get () {
        return this.placement.email
      },

      set (value) {
        this.setPlacementProperty({ property: 'email', value })
      }
    }
  }
}
